import { render, staticRenderFns } from "./CombinePoliciesModal.vue?vue&type=template&id=75bf5178&scoped=true"
import script from "./CombinePoliciesModal.vue?vue&type=script&lang=js"
export * from "./CombinePoliciesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bf5178",
  null
  
)

export default component.exports